import _ from 'lodash';

import { CampaignTargetVerticals } from 'data/trident-campaigns';
import {
  productDisplayName,
  productFromApi,
} from 'omega-rtc/views/ucd/content-config/adapters';

export const TRIDENT_CVP_FALLBACK = 'Others';

export type ProductOfferingOption = {
  key: string;
  text: string;
  value: string;
};

const TRIDENT_CVP_FALLBACK_OPTION: ProductOfferingOption = {
  key: TRIDENT_CVP_FALLBACK,
  text: TRIDENT_CVP_FALLBACK,
  value: TRIDENT_CVP_FALLBACK,
};

export const isContentPortalProductsEnabled = (): boolean =>
  _.get(window, 'Grab.config.ENABLE_CONTENT_PORTAL_PRODUCTS', false) === true;

const normalizeContentPortalProduct = (product: any): any => {
  if (!product) {
    return {};
  }
  if (product.body || product.meta) {
    return productFromApi(product);
  }
  return product;
};

const normalizeVertical = (vertical?: string): string =>
  String(vertical || '').trim().toLowerCase();

const getContentPortalVertical = (vertical: string): string =>
  _.get(CampaignTargetVerticals, vertical, vertical);

export const getContentPortalProductOfferingOptions = ({
  products = [],
  vertical = '',
}: {
  products?: any[];
  vertical?: string;
}): ProductOfferingOption[] => {
  if (!vertical) {
    return [];
  }

  const selectedVertical = normalizeVertical(getContentPortalVertical(vertical));

  const productOptions = products
    .map(normalizeContentPortalProduct)
    .filter(product => Boolean(product.key) && normalizeVertical(product.vertical) === selectedVertical)
    .map(product => ({
      key: product.key,
      text: productDisplayName(product),
      value: product.key,
    }));

  if (productOptions.some(option => option.value === TRIDENT_CVP_FALLBACK)) {
    return productOptions;
  }

  return [...productOptions, TRIDENT_CVP_FALLBACK_OPTION];
};

export const getNextTargetVerticalCVP = ({
  currentValue = '',
  hasLoadedProducts,
  options,
  selectedVertical = '',
}: {
  currentValue?: string;
  hasLoadedProducts: boolean;
  options: ProductOfferingOption[];
  selectedVertical?: string;
}): string => {
  if (!selectedVertical) {
    return '';
  }

  if (!hasLoadedProducts) {
    return currentValue;
  }

  if (_.isEmpty(options) || options.every(option => option.value === TRIDENT_CVP_FALLBACK)) {
    return TRIDENT_CVP_FALLBACK;
  }

  if (currentValue && options.some(option => option.value === currentValue)) {
    return currentValue;
  }

  return '';
};
